import { Box, TableCell, TableRow } from "@mui/material";

import { useTranslation } from "react-i18next";

import React from "react";

export const FeatureTableRow = ({ selectedFeature, field, value }) => {
  const { t } = useTranslation("main");

  const propertiesWithUnits = {
    area: "m²",
    percent: "%",
    pa: "m",
    height: "m",
    crown_diameter: "m",
    shape_length: "m",
    biomass: "kg",
    co2: "tCO₂e",
    m2_catastro: "m²",
    // Solar fields
    SolEnergia: "kWh",
    SolCO2: "tCO₂",
    SolAhorro: "€",
    SolAreaPnl: "m²",
    SolHRA: "kWh/m²",
    SolHRM: "kWh/m²",
    SolTA: "°C",
    SolTM: "°C",
    SolRDNA: "kWh/m²",
    SolRDNM: "kWh/m²",
    SolRAOA: "kWh/m²",
    SolRAOM: "kWh/m²",
    Potencia_instalada_kWp: "kWp",
    Potencia_modulos: "W",
    Ratio_kWp_m2: "kWp/m²",
    "Coste_€_kWp": "€/kWp",
    Superficie_cubierta: "m²",
    Superficie_fv_percent: "%",
  };

  const isValidDate = (dateString) => {
    if (typeof dateString !== "string") return false;

    // Expresión regular para validar formatos YYYY-MM-DD y con hora opcional
    const dateRegex = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?)?$/;

    if (!dateRegex.test(dateString)) return false;

    // Si el formato es YYYY-MM-DDZ, completar con T00:00:00Z
    if (/^\d{4}-\d{2}-\d{2}Z$/.test(dateString)) {
      dateString = dateString.replace("Z", "T00:00:00Z");
    }

    const date = new Date(dateString);
    return !isNaN(date.getTime());
  };

  const isURL = (str) => {
    try {
      new URL(str);
      return true;
    } catch (_) {
      return false;
    }
  };

  const formatNumber = (value) => {
    return parseFloat(value)
      ?.toFixed(2)
      ?.replace(".", ",")
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <TableRow
      key={`${selectedFeature?.id}-${field}`}
      sx={{
        "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" }, // Color más oscuro solo en filas pares
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row">
        {t(field)}
      </TableCell>
      <TableCell>
        {isValidDate(value) ? (
          new Date(value).toISOString().split("T")[0]
        ) : isURL(value) ? (
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "blue",
              textDecoration: "underline",
            }}
          >
            {t("link")}
          </a>
        ) : (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <span>
              {Object.keys(propertiesWithUnits).includes(field)
                ? `${formatNumber(value)} ${propertiesWithUnits[field]}`
                : t(value)}
            </span>
          </Box>
        )}
      </TableCell>
    </TableRow>
  );
};
